import React from "react";
import {CheckCircle, HighlightOff} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {statuses} from "../Config";

const useStyle = makeStyles(() => {
    return {
        passed: {
            color: statuses.healthy.colour
        },
        failed: {
            color: statuses.faulty.colour
        },
        noButton: {
            width: 24,
            height: 24,
            margin: "0 8px"
        }
    }
})

export default function({passedTest, onClick}){
    const classes = useStyle()
    const {passed, failed, noButton} = classes
    if (onClick){
        return <IconButton onClick={onClick}>
            {passedTest ?
                <CheckCircle className={passed}/> :
                <HighlightOff className={failed}/>
            }
        </IconButton>
    }
    if (passedTest) {
        return <CheckCircle className={`${passed} ${noButton}`}/>
    }
    return <HighlightOff className={`${failed} ${noButton}`}/>
}
